import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  formatUsageBillingMonthLabel,
  getCurrentUsageBillingMonthKey,
  isUsageBillingMonthBeforeCurrent,
  shiftUsageBillingMonthKey,
} from "./usage-billing-time";

const ONE_MONTH = 1;

type UsageBillingMonthPickerProps = {
  /** "YYYY-MM" in the billing timezone. */
  monthKey: string;
  onChange: (monthKey: string) => void;
};

export function UsageBillingMonthPicker({
  monthKey,
  onChange,
}: UsageBillingMonthPickerProps) {
  const canGoToNextMonth = isUsageBillingMonthBeforeCurrent(monthKey);

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={() =>
            onChange(shiftUsageBillingMonthKey(monthKey, -ONE_MONTH))
          }
          aria-label="Previous month"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="min-w-36 text-center text-sm font-medium">
          {formatUsageBillingMonthLabel(monthKey)}
        </span>
        <Button
          variant="outline"
          size="icon"
          onClick={() =>
            onChange(shiftUsageBillingMonthKey(monthKey, ONE_MONTH))
          }
          disabled={!canGoToNextMonth}
          aria-label="Next month"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
      {/* Reserves its line even when hidden so the header doesn't jump. */}
      <button
        type="button"
        onClick={() => onChange(getCurrentUsageBillingMonthKey())}
        className={cn(
          "text-xs text-blue-600 hover:underline",
          !canGoToNextMonth && "invisible",
        )}
      >
        Jump to current month
      </button>
    </div>
  );
}
